module.exports = __webpack_public_path__ + "img/ma.d5a0a67f.jpg";